import React from 'react';
import Layout from '../components/Layout';
import SEO from '../components/SEO';

const PrivacyPolicy = (props) => (
  <Layout {...props}>
    <SEO
      title="Privacy Page | Powerplay"
      description="This page is to inform app visitors regarding Powerplay's policies with the collection, use, and disclosure of Personal Information if anyone decided to use the Powerplay app."
    />

    <section className="privacy-main">
      <div className="container">
        <div className="flex-row">
          <div className="col col-10 offset-1">
            <h1>Privacy Policy</h1>
            <p>Last updated: 22 March 2020</p>
            <p>
              Coffer Internet Services Pvt. Ltd. operates the Powerplay app,
              which provides the SERVICE.
            </p>
            <p>
              This page is to inform app visitors regarding our policies with
              the collection, use, and disclosure of Personal Information if
              anyone decided to use our Service, “Powerplay”.
            </p>
            <p>
              If you choose to use our Service, then you agree to the collection
              and use of information in relation to this policy. The Personal
              Information that we collect is used for providing and improving
              the Service. We will not use or share your information with anyone
              except as described in this Privacy Policy.
            </p>
            <h2>Information Collection and Use</h2>
            <p>
              For a better experience, while using our Service, we may require
              you to provide us with certain personally identifiable
              information, including but not limited to your name, phone number,
              and postal address. The information that we collect will be used
              to contact or identify you.
            </p>
            <h2>Log Data</h2>
            <p>
              We want to inform you that whenever you visit our Service, we
              collect information that your app sends to us which is called Log
              Data. This Log Data may include information such as your device
              details, photos that you share, and other statistics. We use the
              best security solutions offered in the market.
            </p>

            <h2>Service Providers</h2>
            <p>
              We may employ third-party companies and individuals due to the
              following reasons:
            </p>
            <ul>
              <li>To facilitate our Service;</li>
              <li>To provide the Service on our behalf;</li>
              <li>To perform Service-related services; or</li>
              <li>To assist us in analyzing how our Service is used.</li>
            </ul>
            <p>
              We want to inform our Service users that these third parties have
              access to your Personal Information. The reason is to perform the
              tasks assigned to them on our behalf. However, they are obligated
              not to disclose or use the information for any other purpose.
            </p>
            <h2>Security</h2>
            <p>
              We value your trust in providing us your Personal Information,
              thus we are striving to use commercially acceptable means of
              protecting it. But remember that no method of transmission over
              the internet, or method of electronic storage is 100% secure and
              reliable, and we cannot guarantee its absolute security.
            </p>
            <h2>Links to Other Sites</h2>
            <p>
              Our Service may contain links to other sites. If you click on a
              third-party link, you will be directed to that site. Note that
              these external sites are not operated by us. Therefore, we
              strongly advise you to review the Privacy Policy of these
              websites. We have no control over and assume no responsibility for
              the content, privacy policies, or practices of any third-party
              sites or services.
            </p>
            <h2>​Changes to This Privacy Policy</h2>
            <p>
              We may update our Privacy Policy from time to time. Thus, we
              advise you to review this page periodically for any changes. We
              will notify you of any changes by posting the new Privacy Policy
              on this page. These changes are effective immediately after they
              are posted on this page.
            </p>
            <h2>Contact Us</h2>
            <p>
              If you have any questions or suggestions about our Privacy Policy,
              do not hesitate to contact us.
            </p>
            <p>
              Best,
              <br />
              Coffer Developers
            </p>
          </div>
        </div>
      </div>
    </section>
  </Layout>
);

export default PrivacyPolicy;
